import instance from "../utils/network";
import { CommonResponse, PubTournament, ReservationResponse } from "./types";

export interface TournamentReservationParams {
  reservationId: number;
  nickName: string;
  phoneNumber: string;
  userId?: number;
  route: string;
}
export interface UserReservationResponse {
  id: number;
  reservationId: number;
  createdAt: Date;
  updatedAt: Date;
  pubName: string;
  pubPhoneNumber: string;
  pubAddress: string;
  pubType: string;
  reservationImage: string;
  startDate: string;
  tournamentName: string;
  tournamentId: number;
  reservationCount: number;
  tournament: PubTournament;
  isCancel: boolean;
  isSpecial: boolean;
}

export function registerReservation(
  data: TournamentReservationParams
): Promise<CommonResponse> {
  return instance.post("/seller/reservation/register", data);
}

export function getReservation(id: number): Promise<ReservationResponse> {
  return instance.get("/seller/reservation/" + id);
}

export function getCurrentReservations(
  id: number
): Promise<{ nickname: string; id: number; userId: number }[]> {
  return instance.get(`/seller/reservation/current_nicknames/${id}`);
}

export function getUserReservationList(
  year: number,
  month: number
): Promise<UserReservationResponse[]> {
  return instance.get(`/nest/reservation?year=${year}&month=${month}`);
}

export function reservationCancel(id: number): Promise<any> {
  return instance.delete(`/nest/reservation/${id}`);
}
